import { useActions, useAppSelector } from '@/hooks'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import Calendar from './FilterCalendar'
import {
  Badge,
  Box,
  Checkbox,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
} from '@mui/material'
import * as React from 'react'
import { filterSystemSelector } from '@/store/filterSystemsSlise'
import IconsSelector from '@/components/Molecules/IconsSelector/Icons'
import IconLampType from '@/components/Atoms/Icons/Devices/IconLampType'

import IconsSelectorDTP from '@/components/Molecules/IconsSelector/IconsDTP'
import { DeviceType } from '@/types/enums'
import { getLineColor } from '@/components/Organisms/Map/MapLightnings'

const FILTERS = [
  { id: 0, name: 'Выбрать все' },
  { id: 1, name: 'Исправны' },
  { id: 2, name: 'Ошибки в работе' },
  { id: 3, name: 'Неисправны' },
]

const FILTERSLIGHTNING = [
  { id: 0, name: 'Выбрать все' },
  { id: 1, name: 'Существующее' },
  { id: 2, name: 'Перспективное' },
  { id: 3, name: 'Прочие' },
]
const FILTERSDTP = [
  { id: 0, name: 'Выбрать все' },
  { id: 3, name: 'Смертельные' },
  { id: 2, name: 'С пострадавшими' },
  { id: 1, name: 'Без пострадавших' },
]
const Filter = () => {
  const { deviceStateFilter, filter, additionalFilter } =
    useAppSelector(filterSystemSelector)
  const {
    setDeviceStateFilter,
    toggleOnChangeDevice,
    setAdditionalStateFilter,
  } = useActions()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const isLightning = filter.length === 1 && filter[0] === DeviceType.lightning

  const isDTP = filter.length === 1 && filter[0] === DeviceType.dtp

  const filterItems = isLightning
    ? FILTERSLIGHTNING
    : isDTP
      ? FILTERSDTP
      : FILTERS

  const filterState =
    isDTP || isLightning ? additionalFilter : deviceStateFilter
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (e: any) => {
    if (
      e.target.nodeName === 'LI' ||
      e.target.nodeName === 'INPUT' ||
      e.target.ariaLabel === 'menu'
    ) {
      return
    }
    setAnchorEl(null)
  }

  const onSelectedFilter = (id: number) => {
    const setFilter =
      isDTP || isLightning ? setAdditionalStateFilter : setDeviceStateFilter

    if (id === 0) {
      setFilter([0])
      return
    }

    const withoutZero = filterState.filter((item) => item !== 0)
    const isSelected = withoutZero.includes(id)

    const filter = isSelected
      ? withoutZero.filter((item) => item !== id)
      : [...withoutZero, id]
    setFilter(filter)
  }

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ maxHeight: 450 }}
      >
        <MenuList>
          <MenuItem key='date'>
            <Calendar />
          </MenuItem>
          {filterItems.map((item, index) => {
            const label = { inputProps: { 'aria-label': item.name } }
            return (
              <MenuItem
                key={index}
                id={item?.id?.toString()}
                onClick={handleClose}
                onClickCapture={() => onSelectedFilter(item.id)}
              >
                <ListItemIcon>
                  <Checkbox
                    {...label}
                    checked={filterState.includes(item.id)}
                  />
                </ListItemIcon>
                <Box
                  display='flex'
                  alignItems='center'
                  gap={1}
                  aria-label='menu'
                >
                  {isLightning ? (
                    <IconLampType
                      htmlColor={getLineColor(item.id)}
                      style={{ display: item.id === 0 ? 'none' : 'block' }}
                    />
                  ) : isDTP ? (
                    <IconsSelectorDTP id={item.id} />
                  ) : (
                    <IconsSelector id={item.id} />
                  )}

                  {item.name}
                </Box>
              </MenuItem>
            )
          })}
        </MenuList>
      </Menu>
      <IconButton onClick={handleClick}>
        <Badge
          color={
            filterState?.length > 0 && !filterState.includes(0)
              ? 'green'
              : 'transparent'
          }
          variant='dot'
        >
          <FilterAltIcon
            htmlColor={'dark-gray'}
            fontSize='large'
          />
        </Badge>
      </IconButton>
    </>
  )
}

export default Filter
